<template>
    <div class="component-question-box">
        <label :id="'question' + fields.number" class="no">{{ fields.number }}</label>
        <article>{{ fields.text }}</article>
        <div class="answer">
            <div class="choice" v-for="(choice, index) in fields.choiceList" :key="index">
                <span @click="selectChoice(fields, choice)"><i class="pe-7s-close" v-if="selectedChoice == choice.number || choice.id == fields.selectedChoiceId"></i></span>
                <p :class="{ 'highlight': selectedChoice == choice.number }">{{ choice.text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fields: Object
    },
    data() {
        return {
            selectedChoice: 0
        }
    },
    created() {
    },
    methods: {
        selectChoice(fields, choice) {
            fields.selectedChoiceId = null;
            this.selectedChoice = choice.number;
            this.$emit('selectedChoice', {
                questionNumber: fields.number,
                questionId: fields.id,
                choiceId: choice.id
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.component-question-box {
    position: relative;
    padding-left: 65px;
    padding-bottom: 20px;
    margin-bottom: 30px;
    border-bottom: 1px dashed #ddd;

    @media only screen and (max-width: $screenExtraSmall) {
        padding-left: 0;
    }

    &:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: none;
    }

    .no {
        position: absolute;
        top: 0;
        left: 0;
        background: #cecac4;
        color: #fff;
        font-size: 20px;
        width: 45px;
        height: 45px;
        text-align: center;
        padding-top: 8px;
        @include borderRadius(1000px);

        @media only screen and (max-width: $screenExtraSmall) {
            position: static;
            margin: 0 auto 15px;
            display: block;
            width: 30px;
            height: 30px;
            font-size: 16px;
            padding-top: 3px;
        }
    }

    article {
        font-size: 16px;
        line-height: 26px;
        padding-bottom: 10px;

        @media only screen and (max-width: $screenExtraSmall) {
            font-size: 14px;
            line-height: 24px;
        }
    }

    .answer {
        padding-left: 30px;

        @media only screen and (max-width: $screenExtraSmall) {
            padding-left: 15px;
        }

        .choice {
            position: relative;
            margin-top: 15px;
            padding-top: 3px;
            padding-left: 45px;

            span {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width: 30px;
                height: 30px;
                border: 1px solid #aaa;
                cursor: pointer;
                text-align: center;

                i {
                    font-size: 29px;
                    color: #333;
                }
            }

            p {
                font-size: 16px;
                line-height: 22px;
                color: #000;

                @media only screen and (max-width: $screenExtraSmall) {
                    font-size: 14px;
                    line-height: 20px;
                }

                &.highlight {
                    color: $mainColor;
                }
            }
        }
    }
}
</style>